module.exports = __webpack_public_path__ + "static/media/chat_Reply.aeef5251.svg";